import React from 'react';
import { Icon } from 'antd';

//合成并插入报告按钮的右箭头
const ArrowRightSvg = () => (
  <svg
    t="1603699593398"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1136"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path d="M992 512L512 32v288H0v384h512v288z" p-id="1137"></path>
  </svg>
);

export const ArrowRightIcon = props => (
  <Icon component={ArrowRightSvg} {...props} />
);

//沙漏
const shalouSvg = () => (
  <svg
    t="1598513157999"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="1.2em"
    height="1.2em"
    p-id="1251"
  >
    <path
      d="M793.6 885.76h-51.2v-179.2c0-99.84-79.36-179.2-179.2-179.2 99.84 0 179.2-79.36 179.2-179.2v-179.2h51.2c15.36 0 25.6-10.24 25.6-25.6s-10.24-25.6-25.6-25.6H281.6c-15.36 0-25.6 10.24-25.6 25.6s10.24 25.6 25.6 25.6h51.2v179.2c0 99.84 79.36 179.2 179.2 179.2-99.84 0-179.2 79.36-179.2 179.2v179.2h-51.2c-15.36 0-25.6 10.24-25.6 25.6s10.24 25.6 25.6 25.6h512c15.36 0 25.6-10.24 25.6-25.6s-12.8-25.6-25.6-25.6z m-409.6-537.6v-179.2h307.2v179.2c0 71.68-61.44 128-135.68 128h-38.4c-74.24 0-133.12-58.88-133.12-128z m307.2 537.6H384v-179.2c0-71.68 61.44-128 135.68-128h38.4c74.24 0 135.68 56.32 135.68 128-2.56 40.96-2.56 179.2-2.56 179.2z"
      p-id="1252"
    ></path>
  </svg>
);

export const shalouIcon = props => <Icon component={shalouSvg} {...props} />;

//
const ReviewSvg = () => (
  <svg
    t="1597375901565"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1884"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M795.4 836.7H228.6c-20.3 0-36.8-16.6-36.8-36.8 0-20.3 16.6-36.8 36.8-36.8h566.9c20.3 0 36.8 16.6 36.8 36.8 0 20.3-16.6 36.8-36.9 36.8zM831.8 508.3H640.9c-0.7-0.3-1.5-0.5-2.3-0.5h-0.1c-24.9 0-45-20.2-45-45 0-14.4 6.7-27.1 17.2-35.4 56.3-33.6 93.9-95.1 93.9-165.5 0-106.4-86.3-192.7-192.7-192.7S319.3 155.5 319.3 262c0 70.3 37.7 131.8 94 165.5 11.2 8.2 18.5 21.4 18.5 36.3 0 22.6-16.7 41.4-38.4 44.5H192.2c-19.8 0-36 16.2-36 36v107.8c0 19.8 16.2 36 36 36h639.6c19.8 0 36-16.2 36-36V544.3c0-19.8-16.2-36-36-36z"
      p-id="1885"
    ></path>
  </svg>
);

export const ReviewIcon = props => <Icon component={ReviewSvg} {...props} />;

const editInfoSvg = () => (
  <svg
    t="1604903726990"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2873"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M1014.642 150.772c-7.923 28.292-14.956 54.581-34.507 70.42-171.054 138.593-308.162 310.68-463.298 464.871-4.074 4.061-8.949 7.641-11.991 12.379-65.929 102.828-181.262 115.945-282.196 154.651-21.67 8.3-55.57-30.316-49.069-53.263 18.317-64.627 36.254-129.378 55.954-193.592 3.332-10.863 13.737-20.27 22.483-28.673 147.544-141.694 295.884-282.56 442.692-425.014 35.012-33.975 65.363-72.802 97.388-109.813 43.243-49.963 103.691-53.987 150.811-7.654 28.364 27.89 62.838 52.147 69.349 96.114 0.846 5.7 1.756 11.387 2.64 17.076 2.149 1.29-2.409 1.207-0.257 2.497v0zM746.265 198.034c-143.031 143.31-285.798 286.353-425.513 426.335 24.065 24.382 50.698 51.374 73.962 74.938 142.838-139.748 286.956-280.736 430.361-421.026-29.209-29.747-55.809-56.826-78.809-80.248v0zM780.431 137.468c35.534 34.035 66.499 63.695 103.078 98.73 6.533-8.912 12.87-19.914 21.406-28.782 61.69-64.018 61.828-63.88-3.146-125.401-1.389-1.318-2.658-2.784-4.08-4.063-17.97-16.119-36.193-16.301-53.943-0.005-20.473 18.801-40.525 38.055-63.316 59.521v0zM250.913 775.782c32.921-13.26 58.889-23.713 81.104-32.654-17.064-20.07-32.667-38.427-51.038-60.045-10.237 31.532-18.925 58.35-30.067 92.699v0zM457.325 1010.618c-95.18 0-190.363 0.146-285.55-0.065-52.12-0.109-98.169-14.202-133.136-56.247-23.055-27.724-29.593-59.946-29.642-94.142-0.291-189.403-1.034-378.814 0.219-568.217 0.664-101.677 63.442-162.274 165.278-162.868 102.874-0.599 205.757-0.022 308.627-0.226 22.538-0.043 44.021 1.736 46.9 30.199 2.109 20.825-14.922 31.334-48.338 31.361-99.987 0.084-199.985-0.147-299.974 0.094-71.519 0.181-112.147 41.233-112.165 112.856-0.072 182.666-0.089 365.333-0.043 547.999 0.01 56.514 38.085 96.863 95.137 97.074 195.173 0.735 390.353 0.596 585.525 0.129 46.174-0.104 76.086-33.055 76.29-83.051 0.51-124.969 0.241-249.947 0.433-374.927 0.017-9.542-2.207-21.578 2.57-28.067 8.038-10.926 21.765-26.173 31.426-25.058 10.109 1.164 19.003 18.963 26.809 30.577 2.697 4.002 0.62 11.255 0.62 17.019 0.011 124.028 0.17 248.059-0.049 372.085-0.182 104.429-49.419 153.352-154.028 153.468-92.305 0.096-184.61 0.022-276.91 0.011v0zM457.325 1010.618z"
      fill=""
      p-id="2874"
    ></path>
  </svg>
);
export const EditInfoIcon = props => (
  <Icon component={editInfoSvg} {...props} />
);

const logoutSvg = () => (
  <svg
    t="1604904850793"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3624"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M576 128c38.4 0 64 25.6 64 64v640c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V192c0-38.4 25.6-64 64-64h384m0-64H192c-70.4 0-128 57.6-128 128v640c0 70.4 57.6 128 128 128h384c70.4 0 128-57.6 128-128V192c0-70.4-57.6-128-128-128z"
      fill="#333333"
      p-id="3625"
    ></path>
    <path d="M576 256h192v512H576z" fill="#FFFFFF" p-id="3626"></path>
    <path
      d="M672 256m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z"
      fill="#333333"
      p-id="3627"
    ></path>
    <path
      d="M672 768m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z"
      fill="#333333"
      p-id="3628"
    ></path>
    <path d="M288 480h640v64h-640z" fill="#333333" p-id="3629"></path>
    <path
      d="M288 512m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z"
      fill="#333333"
      p-id="3630"
    ></path>
    <path
      d="M902.4 486.4l-179.2 179.2c-12.8 12.8-12.8 32 0 44.8 12.8 12.8 32 12.8 44.8 0l179.2-179.2c12.8-12.8 12.8-32 0-44.8-6.4-6.4-32-6.4-44.8 0z"
      fill="#333333"
      p-id="3631"
    ></path>
    <path
      d="M723.2 307.2c-12.8 12.8-12.8 32 0 44.8l179.2 179.2c12.8 12.8 32 12.8 44.8 0 12.8-12.8 12.8-32 0-44.8L768 307.2c-12.8-12.8-32-12.8-44.8 0z"
      fill="#333333"
      p-id="3632"
    ></path>
  </svg>
);
export const LogoutIcon = props => <Icon component={logoutSvg} {...props} />;

const userSvg = () => (
  <svg
    t="1604905248726"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4369"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M515.434 67.979c-245.743 0-444.958 199.214-444.958 444.958 0 245.746 199.214 444.963 444.958 444.963 245.746 0 444.963-199.217 444.963-444.963 0-245.743-199.217-444.958-444.963-444.958v0zM797.275 781.553c-29.633-25.881-80.542-59.684-91.207-66.949v0c-21.819-15.25-89.323-42.434-118.018-50.114-13.463-6.377-13.259-32.942-13.005-39.397h-1.469c44.295-33.205 74.821-99.591 74.821-167.721 0-97.765-22.986-192.057-132.996-192.057-110.287 0-132.996 95.593-132.996 192.057 0 67.346 30.656 134.292 75.116 167.721h-1.759c0.251 6.458 0.454 33.022-13.009 39.397-28.695 7.676-98.407 36.494-118.018 50.114-7.973 5.535-61.71 41.467-90.493 67.625-66.991-69.932-108.151-164.803-108.151-269.292 0-215.024 174.314-389.338 389.338-389.338 215.028 0 389.343 174.314 389.343 389.338 0.001 104.151-40.892 198.748-107.5 268.614v0zM797.275 781.553z"
      p-id="5368"
      fill="#467ef4"
    ></path>
  </svg>
);
export const UserIcon = props => <Icon component={userSvg} {...props} />;

const arrowDownSvg = () => (
  <svg
    t="1604905965213"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5237"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M163.446 275.692h697.108c19.692 0 33.477 25.6 17.723 43.323L537.6 736.492c-11.815 15.754-37.415 15.754-49.23 0L143.753 319.015c-13.785-17.723-1.97-43.323 19.692-43.323z"
      p-id="5238"
    ></path>
  </svg>
);

export const ArrowDownIcon = props => (
  <Icon component={arrowDownSvg} {...props} />
);

const passwordSvg = () => (
  <svg
    t="1604912562386"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6026"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M804.571429 1023.975619 219.428571 1023.975619C165.571048 1023.975619 121.904762 1004.714667 121.904762 950.832762L121.904762 536.356571C121.904762 482.499048 165.571048 438.832762 219.428571 438.832762L219.428571 438.832762 219.428571 292.547048 219.428571 292.547048C219.428571 130.974476 350.403048-0.024381 512-0.024381 673.572571-0.024381 804.571429 130.974476 804.571429 292.547048L804.571429 438.832762C858.428952 438.832762 902.095238 482.499048 902.095238 536.356571L902.095238 950.832762C902.095238 1004.714667 858.428952 1023.975619 804.571429 1023.975619ZM755.809524 292.547048 755.809524 292.547048C755.809524 292.547048 755.809524 292.547048 755.809524 292.547048 755.809524 157.891048 646.631619 48.737524 512 48.737524 377.344 48.737524 268.166095 157.891048 268.166095 292.547048 268.166095 292.547048 268.166095 292.547048 268.166095 292.547048L268.190476 292.547048 268.190476 438.832762 755.809524 438.832762 755.809524 292.547048ZM853.333333 536.356571C853.333333 509.44 831.488 487.594667 804.571429 487.594667L219.428571 487.594667C192.487619 487.594667 170.666667 509.44 170.666667 536.356571L170.666667 950.832762C170.666667 977.773714 192.487619 975.213714 219.428571 975.213714L804.571429 975.213714C831.488 975.213714 853.333333 977.773714 853.333333 950.832762L853.333333 536.356571ZM536.380952 801.109333 536.380952 877.714286C536.380952 891.172571 525.458286 902.095238 512 902.095238 498.541714 902.095238 487.619048 891.172571 487.619048 877.714286L487.619048 801.109333C445.635048 790.235429 414.47619 752.420571 414.47619 707.023238 414.47619 653.165714 458.142476 609.499429 512 609.499429 565.857524 609.499429 609.52381 653.165714 609.52381 707.023238 609.52381 752.420571 578.364952 790.235429 536.380952 801.109333ZM512 658.261333C485.059048 658.261333 463.238095 680.106667 463.238095 707.023238 463.238095 733.96419 485.059048 755.809524 512 755.809524 538.916571 755.809524 560.761905 733.96419 560.761905 707.023238 560.761905 680.106667 538.916571 658.261333 512 658.261333Z"
      p-id="6027"
    ></path>
  </svg>
);
export const PasswordIcon = props => (
  <Icon component={passwordSvg} {...props} />
);

const successSvg = () => (
  <svg
    t="1604914281604"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6990"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M512 96c229.76 0 416 186.24 416 416s-186.24 416-416 416S96 741.76 96 512 282.24 96 512 96z m241.066667 277.888a17.066667 17.066667 0 0 0-24.106667 0l-242.773333 242.773333-116.309334-115.797333a17.066667 17.066667 0 0 0-24.149333 0l-21.077333 21.162667-2.218667 2.688a17.066667 17.066667 0 0 0 2.261333 21.461333l116.224 115.754667h-0.042666l33.194666 33.237333a17.066667 17.066667 0 0 0 24.106667 0l276.053333-276.053333a17.066667 17.066667 0 0 0 0-24.106667z"
      p-id="6991"
    ></path>
  </svg>
);

export const SuccessIcon = props => <Icon component={successSvg} {...props} />;

const imageSvg = () => (
  <svg
    t="1604995169336"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7745"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M866.4576 102.4H157.5424C98.816 102.4 51.2 150.016 51.2 208.7424v567.1424c0 58.7264 47.616 106.3424 106.3424 106.3424h708.9152c58.7264 0 106.3424-47.616 106.3424-106.3424V208.7424C972.8 150.016 925.184 102.4 866.4576 102.4zM157.5424 173.312h708.9152c19.5584 0 35.4304 15.872 35.4304 35.4304v339.5584l-181.4528-181.4528-177.9712 182.8864-108.4416-108.4928-311.9104 320.4608v-552.96c0-19.5584 15.872-35.4304 35.4304-35.4304z m546.56 638.0032H172.4416l262.2976-269.3632 269.3632 269.3632z m197.7856-35.4304c0 19.5584-15.872 35.4304-35.4304 35.4304h-62.3616l-212.6848-212.6848 133.2736-130.4064 180.736 180.736-3.5328 126.9248zM263.8848 385.9456a70.912 70.912 0 1 1 0-141.7728 70.912 70.912 0 0 1 0 141.824z"
      p-id="7746"
    ></path>
  </svg>
);
export const ImageIcon = props => <Icon component={imageSvg} {...props} />;

const fileSvg = () => (
  <svg
    t="1604998884111"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="10650"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M851.2 32H198.4c-38.4 0-64 25.6-64 64v844.8c0 32 32 64 64 64h409.6c38.4 0 64-25.6 64-64v-134.4c0-32 32-64 64-64h108.8c38.4 0 64-25.6 64-64V89.6c12.8-32-19.2-57.6-57.6-57.6zM640 556.8c0 19.2-12.8 32-32 32H320c-19.2 0-32-12.8-32-32v-6.4c0-19.2 12.8-32 32-32h288c19.2 0 32 12.8 32 38.4zM780.8 384c0 19.2-12.8 32-32 32H320c-19.2-6.4-38.4-19.2-38.4-32v-6.4c0-19.2 12.8-32 32-32h428.8c25.6 0 38.4 12.8 38.4 38.4z m0-172.8c0 19.2-12.8 32-32 32H320c-19.2 0-32-12.8-32-32v-6.4c0-19.2 12.8-32 32-32h428.8c19.2 0 32 12.8 32 38.4z"
      p-id="10651"
    ></path>
    <path
      d="M716.8 851.2v89.6c0 32 38.4 44.8 57.6 25.6l128-128c19.2-19.2 6.4-57.6-25.6-57.6h-89.6c-38.4 0-70.4 32-70.4 70.4z"
      p-id="10652"
    ></path>
  </svg>
);
export const FileIcon = props => <Icon component={fileSvg} {...props} />;

const fileSvgLine = () => (
  <svg
    t="1607677985411"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1170"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M676.48 72.96l209.92 211.2 9.6 23.04v620.8l-32 32h-704l-32-32v-832l32-32h494.08l22.4 8.96zM640 320h192l-192-192v192zM192 128v768h640V384H608L576 352V128H192z m512 320H320v64h384V448zM320 576h384v64H320V576z m384 128H320v64h384v-64z"
      p-id="1171"
    ></path>
  </svg>
);
export const FileLineicon = props => (
  <Icon component={fileSvgLine} {...props} />
);

const editFileSvg = () => (
  <svg
    t="1606815590288"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1155"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M64 896 64 128c0-35.312 28.752-64 64-64l640 0c35.312 0 64 28.688 64 64l0 376.248 64-64L896 128c0-70.688-57.312-128-128-128L128 0C57.312 0 0 57.312 0 128l0 768c0 70.688 57.312 128 128 128l352 0 0-64L128 960C92.752 960 64 931.312 64 896zM704 192 192 192l0 64 512 0L704 192zM704 320 192 320l0 64 512 0L704 320zM704 448 192 448l0 64 512 0L704 448zM192 640l256 0 0-64L192 576 192 640zM1005.248 576 960 530.752c-12.504-12.504-28.872-18.752-45.248-18.752s-32.752 6.248-45.248 18.752l-274.752 274.752C582.248 818 544 866.344 544 882.72L512 1024l141.248-32c0 0 64.752-38.248 77.248-50.752l274.752-274.752C1030.248 641.504 1030.248 600.968 1005.248 576zM707.936 918.56c-3.624 3.44-16.16 11.904-31.472 21.656l-82.904-82.904c8.504-11.656 17.968-23.376 23.816-29.184l206.872-206.872 90.504 90.504L707.936 918.56z"
      p-id="1156"
    ></path>
  </svg>
);
export const EditFile = props => <Icon component={editFileSvg} {...props} />;

const soundOpenSvg = () => (
  <svg
    t="1606708813565"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1631"
    width="1.3em"
    height="1.3em"
  >
    <path
      d="M599.104 243.434667V789.546667c0 43.626667-53.866667 64.789333-84.053333 33.024l-140.309334-128.085334H203.392a64 64 0 0 1-64-64V416.981333a64 64 0 0 1 60.224-63.893333l4.309333-0.106667 172.970667 2.88 138.176-145.450666c30.165333-31.786667 84.053333-10.602667 84.053333 33.024z m127.68 12.309333c92.544 47.082667 158.229333 139.392 167.957333 247.829333v56.021334c-9.450667 105.472-71.850667 195.690667-160.426666 243.882666L704.789333 746.666667A245.269333 245.269333 0 0 0 832 531.584a245.333333 245.333333 0 0 0-134.698667-219.029333l29.482667-56.810667z m-53.909333 103.893333a191.466667 191.466667 0 0 1 94.442666 165.44 191.466667 191.466667 0 0 1-92.416 164.202667l-29.653333-56.96a127.488 127.488 0 0 0 58.069333-107.242667 127.488 127.488 0 0 0-60.010666-108.501333l29.568-56.917333z"
      p-id="4348"
      fill="#467ef4"
    ></path>
  </svg>
);

export const SoundOpenIcon = props => (
  <Icon component={soundOpenSvg} {...props} />
);

const soundCloseSvg = () => (
  <svg
    t="1604998884111"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="10650"
    width="1.3em"
    height="1.3em"
    fill="currentColor"
  >
    <path
      d="M250.026667 668.16c8.448 0.426667 24.277333 3.157333 45.653333 14.762667l236.373333 199.253333c6.826667 6.826667 15.786667 10.112 27.136 10.112 9.130667 0 15.786667-0.981333 20.352-3.242667 18.090667-11.392 27.178667-26.197333 27.178667-44.373333V141.781333c0-9.088-2.304-17.194667-6.826667-24.746666a37.546667 37.546667 0 0 0-20.352-16.042667 50.816 50.816 0 0 0-23.722666-5.290667 35.84 35.84 0 0 0-23.765334 8.533334L299.008 303.829333c-18.218667 10.368-32.682667 14.421333-42.325333 15.872h-71.68a99.413333 99.413333 0 0 0-99.114667 99.584v149.333334c0 55.04 44.373333 99.541333 99.157333 99.541333h58.026667v0.128s0.426667-0.085333 1.408-0.128h5.546667zM727.125333 640a44.458667 44.458667 0 0 1-31.488-75.946667l73.429334-73.386666-73.386667-73.386667a44.544 44.544 0 0 1 0-62.933333 44.544 44.544 0 0 1 62.890667 0l73.386666 73.386666 73.429334-73.386666a44.544 44.544 0 0 1 62.933333 0 44.544 44.544 0 0 1 0 62.890666l-73.386667 73.386667 73.386667 73.429333a44.544 44.544 0 0 1-31.445333 75.946667c-11.349333 0-22.826667-4.352-31.488-13.013333l-73.386667-73.386667-73.386667 73.386667a44.245333 44.245333 0 0 1-31.488 13.013333z"
      p-id="4589"
      fill="#467ef4"
    ></path>
  </svg>
);
export const SoundCloseIcon = props => (
  <Icon component={soundCloseSvg} {...props} />
);

const clearSvg = () => (
  <svg
    t="1607927546123"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1140"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M452.225 146.9L111.637 487.488a33.223 33.223 0 0 1-47.132 0c-13.073-13.073-12.9-34.059 0-47.132L405.093 99.768a33.223 33.223 0 0 1 47.132 0 33.223 33.223 0 0 1 0 47.132zM924.232 618.735L583.644 959.323a33.223 33.223 0 0 1-47.132 0c-13.073-13.073-12.901-34.06 0-47.132L877.1 571.603a33.223 33.223 0 0 1 47.132 0c13.073 13.073 12.9 34.23 0 47.132zM451.193 620.799L348.157 723.835a33.223 33.223 0 0 1-47.132 0c-13.073-13.073-12.901-34.058 0-47.131L404.06 573.667a33.223 33.223 0 0 1 47.132 0c13.073 13.073 13.073 34.23 0 47.132zM298.444 524.987l-74.654 74.654a33.223 33.223 0 0 1-47.132 0c-13.073-13.073-12.9-34.059 0-47.132l74.655-74.654a33.223 33.223 0 0 1 47.131 0c12.902 13.073 12.902 34.231 0 47.132zM545.285 772l-74.654 74.653a33.223 33.223 0 0 1-47.132 0c-13.073-13.073-12.901-34.058 0-47.131l74.654-74.655a33.223 33.223 0 0 1 47.132 0 33.223 33.223 0 0 1 0 47.132z"
      p-id="1141"
    ></path>
    <path
      d="M536.34 959.323L64.505 487.66a33.223 33.223 0 0 1 0-47.132c13.073-13.073 34.06-12.9 47.132 0l471.835 471.835a33.223 33.223 0 0 1 0 47.132c-13.073 12.9-34.059 12.9-47.132-0.172zM732.264 763.57L260.43 291.737a33.223 33.223 0 0 1 0-47.132c13.073-13.073 34.06-12.901 47.132 0L779.224 716.44a33.223 33.223 0 0 1 0 47.132c-12.901 13.073-34.059 12.9-46.96 0zM912.363 219.49L804.682 111.637a33.223 33.223 0 0 1 0-47.132c13.073-13.073 34.059-12.9 47.132 0l107.68 107.853a33.223 33.223 0 0 1 0 47.132c-13.072 13.073-34.23 13.073-47.131 0zM587.256 328.719L405.437 146.9a33.223 33.223 0 0 1 0-47.132c13.073-13.073 34.06-12.9 47.132 0L634.56 281.76a33.223 33.223 0 0 1 0 47.132c-13.073 12.901-34.23 12.901-47.304-0.172zM877.1 618.563L695.28 436.743a33.223 33.223 0 0 1 0-47.131c13.073-13.073 34.059-12.901 47.132 0l181.99 181.99a33.223 33.223 0 0 1 0 47.133c-13.072 12.9-34.23 12.9-47.303-0.172z"
      p-id="1142"
    ></path>
    <path
      d="M959.323 219.49L742.24 436.572a33.223 33.223 0 0 1-47.132 0c-13.073-13.073-12.901-34.059 0-47.132l217.082-217.082a33.223 33.223 0 0 1 47.132 0c13.073 12.901 13.073 34.059 0 47.132zM851.642 111.637L634.388 328.72a33.223 33.223 0 0 1-47.132 0c-13.073-13.073-12.9-34.059 0-47.132L804.51 64.505a33.223 33.223 0 0 1 47.132 0c13.073 13.073 12.9 34.06 0 47.132z"
      p-id="1143"
    ></path>
  </svg>
);

export const ClearIcon = props => <Icon component={clearSvg} {...props} />;

const loginUserSvg = () => (
  <svg
    t="1607927546123"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1140"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M504.951 511.98c93.49 0 169.28-74.002 169.28-165.26 0-91.276-75.79-165.248-169.28-165.248-93.486 0-169.287 73.972-169.279 165.248-0.001 91.258 75.793 165.26 169.28 165.26z m77.6 55.098H441.466c-120.767 0-218.678 95.564-218.678 213.45V794.3c0 48.183 97.911 48.229 218.678 48.229H582.55c120.754 0 218.66-1.78 218.66-48.229v-13.77c0-117.887-97.898-213.45-218.66-213.45z"
      p-id="3136"
    ></path>
  </svg>
);

export const LoginUserIcon = props => (
  <Icon component={loginUserSvg} {...props} />
);

const loginPassSvg = () => (
  <svg
    t="1607927546123"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1140"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M512 725.333333C558.933333 725.333333 597.333333 686.933333 597.333333 640 597.333333 592.64 558.933333 554.666667 512 554.666667 465.066667 554.666667 426.666667 593.066667 426.666667 640 426.666667 686.933333 465.066667 725.333333 512 725.333333M768 341.333333C814.933333 341.333333 853.333333 379.733333 853.333333 426.666667L853.333333 853.333333C853.333333 900.266667 814.933333 938.666667 768 938.666667L256 938.666667C209.066667 938.666667 170.666667 900.266667 170.666667 853.333333L170.666667 426.666667C170.666667 379.306667 209.066667 341.333333 256 341.333333L298.666667 341.333333 298.666667 256C298.666667 138.24 394.24 42.666667 512 42.666667 629.76 42.666667 725.333333 138.24 725.333333 256L725.333333 341.333333 768 341.333333M512 128C441.173333 128 384 185.173333 384 256L384 341.333333 640 341.333333 640 256C640 185.173333 582.826667 128 512 128Z"
      p-id="3893"
    ></path>
  </svg>
);

export const LoginPassIcon = props => (
  <Icon component={loginPassSvg} {...props} />
);

const loginEamilSvg = () => (
  <svg
    t="1607927546123"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1140"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
  >
    <path
      d="M498.688 563.2c8.192 7.168 19.456 7.168 27.648 0l289.792-268.288c5.12-10.24 4.096-26.624-16.384-26.624l-573.44 1.024c-15.36 0-27.648 14.336-16.384 26.624L498.688 563.2zM819.2 409.6c0-13.312-16.384-20.48-25.6-11.264l-225.28 208.896c-15.36 14.336-34.816 21.504-55.296 21.504s-39.936-7.168-55.296-21.504L231.424 398.336c-10.24-9.216-25.6-2.048-25.6 11.264v266.24c0 33.792 27.648 61.44 61.44 61.44h491.52c33.792 0 61.44-27.648 61.44-61.44-1.024 0-1.024-184.32-1.024-266.24z"
      p-id="2561"
    ></path>
  </svg>
);

export const LoginEamilIcon = props => (
  <Icon component={loginEamilSvg} {...props} />
);

const loginTimeSvg = () => (
  <svg
    t="1607927546123"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1140"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path
      d="M512 85.333333C276.48 85.333333 85.333333 276.48 85.333333 512S276.48 938.666667 512 938.666667 938.666667 747.52 938.666667 512 747.52 85.333333 512 85.333333z m133.12 492.657778h-170.666667c-15.928889 0-28.444444-12.515556-28.444444-28.444444V303.786667c0-15.928889 12.515556-28.444444 28.444444-28.444445s28.444444 12.515556 28.444445 28.444445v218.453333h142.222222c15.928889 0 28.444444 12.515556 28.444444 28.444444s-13.653333 27.306667-28.444444 27.306667z"
      p-id="3350"
    ></path>{' '}
  </svg>
);

export const LoginTimeIcon = props => (
  <Icon component={loginTimeSvg} {...props} />
);

const helpSvg = () => (
  <svg
    t="1606708813565"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1631"
    width="1.3em"
    height="1.3em"
  >
    <path
      d="M515.530406 770.231319c4.366448 0 8.812713-0.267083 13.284561-0.800225 42.889833-5.14723 79.310324-35.124985 92.75452-76.437903 1.01205-3.093455-0.452301-6.40078-3.40761-7.760754-2.928702-1.359974-6.469342-0.186242-8.119935 2.586918-0.159636 0.267083-17.198707 27.79095-83.542718 36.752042-9.930163 1.333368-19.594267 2.02717-28.752858 2.02717-46.483684-0.026606-67.196425-17.548678-67.382667-17.709337-2.342348-2.080382-5.910617-2.133593-8.306176-0.106424-2.422166 2.02717-2.981914 5.547343-1.331321 8.241708C440.960037 749.82864 477.273081 770.231319 515.530406 770.231319zM872.252901 359.078145c-0.586354 0-1.118474 0.106424-1.677199 0.106424C831.705416 190.893678 683.175591 65.355497 505.09473 65.355497c-182.979428 0-334.916862 132.473127-368.595916 307.724547-32.745798 5.894244-57.665351 34.671661-57.665351 69.477374l0 139.300626c0 39.045271 31.309076 70.703295 69.965491 70.703295 21.804608 0 41.052998-10.29446 53.858652-26.110681 30.934546 81.82254 93.922113 147.803277 173.627433 182.610014 0.191358-0.415462 1.700735-3.348258 3.514033-5.685489 1.257643-1.620917 2.660596-2.952238 3.868097-2.952238 1.251503 0 2.396583 0.453325 3.381004 1.147126-18.450211-13.735839-85.086887-84.33271-99.516528-182.853561-6.336312-43.366693 26.143427-85.932138 63.975057-92.973508 60.727083-11.308557 121.134895-24.189935 181.861978-35.284621 38.603203-7.04137 64.987107-28.217668 81.120552-63.475683 3.780093-8.241708 9.238408-24.910343 11.741415-48.940642 0.665149-3.573385 3.593851-6.320962 7.348362-6.320962 2.503007 0 4.632507 1.280156 6.043646 3.120061l1.677199-1.039679c23.934109 34.751478 71.403237 111.695918 78.218456 192.827727 7.827269 92.76066 3.460822 156.289556-67.542302 221.285872-0.079818 0.079818-0.186242 0.186242-0.292666 0.267083-0.985444 1.066285-1.570775 2.453888-1.570775 3.973498 0 2.000564 1.065262 3.707438 2.609431 4.747117 0.585331 0.240477 1.171686 0.559748 1.757017 0.800225 0.478907 0.106424 0.931209 0.267083 1.411139 0.267083 0.479931 0 0.905626-0.159636 1.331321-0.267083 1.01205-0.533143 1.969864-1.147126 2.955308-1.680269 71.802326-39.552831 126.884852-105.615433 152.336524-185.066973 10.302647 15.308661 26.436092 26.323529 45.178969 30.163997-30.057573 136.713708-151.990646 222.272339-303.050084 235.261165-9.052167-22.456455-31.335682-38.405705-57.505715-38.405705-34.183544 0-61.898769 27.070542-61.898769 60.435441s27.714202 60.408835 61.898769 60.408835c27.554566 0 50.637284-17.709337 58.650795-42.032302 174.859493-14.21577 315.02993-118.150934 344.289324-279.640931 25.850761-10.80202 44.007283-36.165688 44.007283-65.769936L944.083879 430.42203C944.081833 391.029858 911.920342 359.078145 872.252901 359.078145zM807.744701 399.564231C762.140037 276.026614 643.960451 187.773617 504.935094 187.773617c-138.440026 0-256.192893 87.505983-302.224276 210.243375-2.289136-2.800789-4.978385-5.200442-7.614421-7.627724C221.160006 240.820788 349.882716 127.0977 505.09473 127.0977c154.467047 0 282.789645 112.602567 309.705668 261.131369C812.137755 391.803477 809.68796 395.537522 807.744701 399.564231zM376.292202 809.063743c-0.00307-0.001023-0.005117-0.002047-0.008186-0.00307C376.255363 809.125141 376.25434 809.133328 376.292202 809.063743z"
      p-id="1823"
      fill="#467ef4"
    ></path>
  </svg>
);

export const HelpSvgIcon = props => <Icon component={helpSvg} {...props} />;

const lungSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="1.3em"
    height="1.3em"
    fill="currentColor"
  >
    <path d="M836.440816 831.216327c-5.746939 0-12.016327-0.522449-18.285714-1.044898-132.702041-16.195918-236.146939-126.432653-235.62449-251.820409 0-22.465306-1.567347-52.244898-3.134694-76.277551-1.044898-18.285714-2.089796-33.436735-2.089796-43.363265 0-21.942857 13.061224-56.42449 21.420409-74.710204 13.583673-32.391837 36.04898-76.277551 75.755102-85.681633 40.228571-9.404082 80.979592 20.37551 108.146938 43.885715 119.640816 102.4 165.093878 238.236735 140.016327 415.346938-6.269388 47.542857-37.093878 73.665306-86.204082 73.665307z m-145.763265-493.191837c-2.089796 0-4.179592 0-6.269388 0.522449-15.673469 3.657143-31.346939 24.032653-47.020408 61.12653v0.522449c-10.44898 25.077551-17.763265 48.587755-17.763265 58.514286 0 8.359184 1.044898 23.510204 2.089796 40.75102 1.567347 24.555102 3.657143 55.379592 3.134694 79.412245-0.522449 103.967347 86.726531 196.440816 198.530612 210.02449 46.497959 5.746939 55.902041-16.718367 58.514286-37.093877 22.987755-164.04898-16.718367-284.212245-125.910205-377.730613-27.689796-24.032653-49.632653-36.04898-65.306122-36.048979zM187.559184 831.216327c-48.587755 0-79.934694-26.122449-86.726531-73.665307-25.077551-177.110204 20.897959-312.946939 140.016327-415.346938 27.167347-23.510204 67.918367-53.289796 108.146938-43.885715 39.706122 9.404082 62.171429 53.289796 75.755102 85.681633 7.836735 18.808163 21.420408 53.289796 21.420409 75.232653 0 9.404082-1.044898 25.077551-2.089796 43.363265-1.567347 24.032653-3.134694 53.812245-3.134694 76.277551 0.522449 124.865306-102.922449 235.62449-235.62449 251.820409-5.746939 0-12.016327 0.522449-17.763265 0.522449z m145.763265-493.191837c-15.673469 0-37.616327 12.016327-65.306122 35.52653-109.191837 94.040816-149.420408 213.681633-125.910205 377.730613 2.612245 20.37551 12.016327 42.840816 58.514286 37.093877 111.804082-13.583673 199.053061-106.057143 198.530612-210.02449 0-24.032653 1.567347-54.857143 3.134694-79.412244 1.044898-17.240816 2.089796-32.391837 2.089796-40.751021 0-9.926531-7.314286-33.436735-17.763265-58.514286v-0.522449c-15.673469-36.571429-31.346939-57.469388-47.020408-61.12653h-6.269388zM512 382.432653c-11.493878 0-20.897959-9.404082-20.897959-20.897959V213.681633c0-11.493878 9.404082-20.897959 20.897959-20.89796s20.897959 9.404082 20.897959 20.89796v147.853061c0 11.493878-9.404082 20.897959-20.897959 20.897959z"></path>
    <path d="M425.795918 467.069388c-5.22449 0-10.44898-2.089796-14.628571-6.269388-8.359184-8.359184-8.359184-21.420408 0-29.779592l84.636735-84.636735c8.359184-8.359184 21.420408-8.359184 29.779591 0 8.359184 8.359184 8.359184 21.420408 0 29.779592L440.42449 461.322449c-4.179592 3.657143-9.404082 5.746939-14.628572 5.746939z"></path>
    <path d="M598.204082 467.069388c-5.22449 0-10.44898-2.089796-14.628572-6.269388L498.416327 376.163265c-8.359184-8.359184-8.359184-21.420408 0-29.779592 8.359184-8.359184 21.420408-8.359184 29.779591 0l84.636735 84.636735c8.359184 8.359184 8.359184 21.420408 0 29.779592-3.657143 4.179592-9.404082 6.269388-14.628571 6.269388z"></path>
  </svg>
);
export const LungSvgIcon = props => <Icon component={lungSvg} {...props} />;

const replaceText = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="1.1em"
    height="1.1em"
    fill="currentColor"
  >
    <path d="M930.816 906.5472H98.0992V106.9568H930.816v799.5904z m-761.0368-71.68H859.136V178.6368H169.7792v656.2304z"></path>
    <path d="M739.84 463.9744H278.784v-71.68h311.552l-49.2544-61.3376 55.8592-44.9024zM423.7312 715.3664l-142.8992-177.8688h461.056v71.68H430.3872l49.2544 61.3376z"></path>
  </svg>
);
export const ReplaceTextIcon = props => (
  <Icon component={replaceText} {...props} />
);

const submitSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1185"
    width="1.3em"
    height="1.3em"
    fill="currentColor"
  >
    <path d="M439.488 960l124.416-169.984-124.416-35.84L439.488 960 439.488 960 439.488 960M0 559.936l353.472 107.072 435.328-369.6-337.408 398.144 377.92 116.736L1024 64.064 0 559.936 0 559.936 0 559.936M0 559.936"></path>
  </svg>
);
export const SubmitIcon = props => <Icon component={submitSvg} {...props} />;

const referralSvg = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 136.5 117.1"
    width="1.3em"
    height="1.3em"
    fill="currentColor"
  >
    <path
      d="M98.1,91.9c-2.1-0.4-4.2,0.1-5.9,1.3c-7.1,5.1-15.6,7.8-24.3,7.6c-1.1,0-2.2-0.1-3.4-0.2
	c-0.3,0-0.5-0.1-0.8-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.9-0.1-1.8-0.3-2.6-0.4c-0.4-0.1-0.8-0.2-1.1-0.2l-0.4-0.1
	c-0.9-0.2-1.7-0.4-2.5-0.7c-0.2-0.1-0.5-0.2-0.7-0.2L55,98.6c-0.8-0.3-1.9-0.7-2.8-1.1c-0.2-0.1-0.3-0.1-0.5-0.2l-0.1-0.1
	c-1.3-0.6-2.3-1.1-3.2-1.6l-0.1-0.1c-3.5-2-6.7-4.4-9.5-7.2l-0.1-0.1c-0.9-0.9-1.7-1.8-2.5-2.8c-0.1-0.1-0.2-0.2-0.2-0.3
	c-0.1-0.1-0.2-0.2-0.2-0.4c-5.7-7.2-8.9-16-9.1-25.2h8.7c0.7,0,1.4-0.4,1.7-1c0.3-0.6,0.3-1.4-0.1-2L20.2,31.3
	c-0.4-0.5-1-0.9-1.6-0.8c-0.6,0-1.3,0.3-1.6,0.8L0.3,56.8c-0.6,0.9-0.3,2.1,0.6,2.7c0.3,0.2,0.7,0.3,1,0.3h8.8
	c0.2,11.4,3.7,22.5,10.1,31.9l0.1,0.1l0.2,0.4c0.5,0.8,1.1,1.4,1.6,2.2l0.7,0.9l0.5,0.7c0.9,1.2,1.9,2.3,3.3,3.7l0.1,0.1
	c0.1,0.1,0.2,0.2,0.2,0.2c3.8,3.8,8.1,7.2,12.9,9.9c0.1,0.1,0.3,0.2,0.4,0.2c1.3,0.7,2.6,1.3,4.2,2c0.2,0.1,0.3,0.1,0.5,0.2
	c0.2,0.1,0.4,0.2,0.6,0.2c1.3,0.5,2.7,1,3.7,1.4l0.3,0.1c0.5,0.2,1,0.4,1.5,0.5c1.1,0.4,2.3,0.6,3.4,0.9l0.5,0.1
	c0.5,0.1,1.1,0.3,1.7,0.4c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.4,0.1,0.7,0.1c0.8,0.1,1.6,0.2,2.4,0.4l0.8,0.1c0.2,0,0.4,0.1,0.5,0.1
	s0.4,0.1,0.6,0.1c13.7,1.4,27.5-2.3,38.7-10.3c3.6-2.5,4.4-7.6,2-11.3C102,93.5,100.2,92.2,98.1,91.9L98.1,91.9z M136.3,58.3
	c-0.3-0.6-1-1-1.7-1h-8.8c-0.2-11.4-3.7-22.4-10.1-31.8c-0.1-0.2-0.2-0.4-0.3-0.5c-0.8-1.1-1.6-2.2-2.5-3.2
	c-0.2-0.3-0.3-0.4-0.4-0.5c-5.7-7.1-13.1-12.8-21.5-16.4C91,4.8,91,4.7,90.9,4.7l-0.4-0.2C89.2,4,87.8,3.5,86.4,3l-0.5-0.2
	c-0.3-0.1-0.6-0.2-1-0.3c-1.3-0.4-2.5-0.7-3.6-1l-0.6-0.1c-0.5-0.1-0.9-0.2-1.4-0.3c-0.1,0-0.2-0.1-0.4-0.1
	c-0.2-0.1-0.4-0.1-0.6-0.1c-0.6-0.1-1.3-0.2-1.9-0.2c-0.3-0.1-0.6-0.1-0.9-0.1c-0.2,0-0.4-0.1-0.7-0.1l-1.2-0.2
	c-1.5-0.1-3-0.2-4.6-0.2c-0.5,0-0.8-0.1-1,0C56.3,0,45,3.7,35.3,10.5c-3.6,2.5-4.5,7.6-2,11.3c1.2,1.8,3.1,3,5.2,3.3
	c2.1,0.4,4.2-0.1,5.9-1.3c8.1-5.8,18-8.4,27.8-7.5c0.2,0,0.5,0.1,0.7,0.1l0.4,0.1c1.1,0.1,2.1,0.3,2.9,0.5l0.9,0.2l0.4,0.1
	c0.8,0.2,1.8,0.4,2.8,0.7c0.2,0.1,0.3,0.1,0.5,0.2l0.4,0.1c1.1,0.4,2.2,0.8,3.1,1.1c0.2,0.1,0.3,0.1,0.4,0.2
	c6.1,2.7,11.5,6.8,15.7,11.9c5.9,7.3,9.3,16.4,9.6,25.8h-8.7c-0.7,0-1.4,0.4-1.7,1c-0.3,0.6-0.3,1.4,0.1,2l16.7,25.5
	c0.4,0.5,1,0.9,1.6,0.9s1.3-0.3,1.6-0.8l16.7-25.5C136.6,59.7,136.5,59,136.3,58.3L136.3,58.3z"
    />
  </svg>
);
export const ReferralIcon = props => (
  <Icon component={referralSvg} {...props} />
);

const aiSvg = () => (
  <svg
    t="1629186219480"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2261"
    width="1.3em"
    height="1.3em"
    fill="currentColor"
  >
    <path d="M501.824 32C303.552 32 141.504 176.992 141.504 357.76c0 23.712 2.816 47.104 8.32 69.856l-51.008 114.208a32 32 0 0 0 24.704 44.736c54.272 7.744 76.672 31.168 76.672 77.312v111.552a64 64 0 0 0 64 64h20.704a64 64 0 0 1 64 64V960a32 32 0 0 0 32 32h345.6a32 32 0 0 0 0-64h-313.6v-24.608a128 128 0 0 0-128-128h-20.736v-111.552c0-65.664-32.192-110.688-91.2-131.136l39.872-89.28a31.968 31.968 0 0 0 1.568-21.792 233.088 233.088 0 0 1-8.896-63.904c0-143.712 131.936-261.76 296.32-261.76s296.32 118.016 296.32 261.76a32 32 0 0 0 64 0C862.144 176.992 700.064 32 501.824 32zM904 448a32 32 0 0 0-32 32v360a32 32 0 0 0 64 0V480a32 32 0 0 0-32-32z"></path>
    <path d="M673.888 466.656c-11.744-25.568-48.416-24.64-58.816 1.536l-132.8 333.76a32 32 0 0 0 59.488 23.68l32.608-81.92c0.576 0.032 1.088 0.32 1.664 0.32h154.848l38.176 83.104a31.968 31.968 0 1 0 58.144-26.72l-153.312-333.76zM599.68 680l47.264-118.72 54.528 118.72H599.68z"></path>
  </svg>
);
export const AIIcon = props => <Icon component={aiSvg} {...props} />;
